import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { PeriodisationSummaryProps } from "models/propTypes/invoicePropTypes";
//#endregion
//#region components
import { Button, Grid } from "@mui/material";
import { DetailsTableViewSmall } from "components/common";
//#endregion
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";
import { AccrualHelper, LocalizationHelperInstance } from "utils/helpers";

const PeriodisationSummary: React.FC<PeriodisationSummaryProps> = (props) => {
  const { value, onEditClick, editButtonLabel } = props;

  return (
    <Grid container spacing={2} alignItems="center">
      {AccrualHelper.getPeriodisationExists(value) ? (
        <Grid container item>
          <DetailsTableViewSmall
            detailsList={
              AccrualHelper.getIsAdvancedConfiguration(value)
                ? AccrualHelper.getAdvancedPeriodisationKeyValueArray(value)
                : AccrualHelper.getSimplifiedPeriodisationKeyValueArray(value)
            }
          />
        </Grid>
      ) : (
        <></>
      )}
      {onEditClick && (
        <Grid item>
          <Button className={clsx(cssExports.button, cssExports.btnSmall)} onClick={props.onEditClick}>
            {editButtonLabel ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Edit)}
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default PeriodisationSummary;
